export interface ChangePasswordRequest {
  current_password: string
  new_password: string
  new_password_repeat: string
}

export interface ChangePasswordResponse {
  message: string
}
